import orgs from "./orgs";
import users from "./users";
import integrations from "./integrations";
import apps from "./apps";
import errors from "./errors";
import saveStates from "./saveStates";
import viewing from "./viewing";
import dialogData from "./dialogData";
import sharingTokens from "./sharingTokens";
import saveBar from "./saveBar";
import changeRequests from "./changeRequests";
import { combineReducers } from "redux";
import {
	notifications,
	reminders,
	userFeeds,
	webrtcPlay,
	playSettings,
	alerts,
	entityIcons,
	cameraClusters,
	videoTours,
	deviceAlarmMappings,
	listLookupData,
	ptzPrivileges
} from "orion-components/GlobalData/Reducers";
import { user, identity, organization } from "orion-components/Session/Reducers";

import { dialog, loading, global, persisted, profile } from "orion-components/AppState/Reducers";
import { default as login } from "../Login/reducers";
import { default as dock } from "orion-components/Dock/Reducers";
import { default as contextualData } from "orion-components/ContextualData/Reducers";
import serviceReducers from "orion-components/Services";

import optimist from "redux-optimist";

import componentState from "orion-components/SharedComponents/ComponentState/redux/componentStateReducer";

const rootReducer = optimist(
	combineReducers({
		session: combineReducers({
			identity,
			user,
			login,
			userFeeds,
			organization
		}),
		globalData: combineReducers({
			notifications,
			reminders,
			orgs,
			users,
			integrations,
			apps,
			changeRequests,
			alerts,
			entityIcons,
			cameraClusters,
			videoTours,
			deviceAlarmMappings,
			listLookupData
		}),
		contextualData,
		appState: combineReducers({
			dock,
			errors,
			global,
			saveStates,
			viewing,
			dialogData,
			loading,
			dialog,
			sharingTokens,
			saveBar,
			persisted,
			contextPanel: combineReducers({
				profile
			})
		}),
		webrtcPlay,
		playSettings,
		ptzPrivileges,
		componentState,
		...serviceReducers
	})
);

export default rootReducer;
